import React from 'react';

function LogoSection({ isCollapsed, onToggle }) {
  return (
    <div className={`logo-section ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="logo-container">
        <div className="logo-badge">
          <img
            src="/logo.png"
            alt="Ransilu logo"
            className="logo-image"
          />
        </div>
      </div>
      <button className="sidebar-toggle-btn" onClick={onToggle} aria-label="Toggle Sidebar">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M9 3v18" />
        </svg>
      </button>
    </div>
  );
}

export default LogoSection;
